let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("duiw3")).then(() => parcelRequire('9hb7e'));